<script lang="ts" setup>
import type { ToastData } from '@/objects/ToastData';
import { useToastStore } from '@/stores/';
import { ToastComp } from '@/components';

const toastStore = useToastStore();

const remove = (toast: ToastData) => {
    toastStore.remove(toast);
};
</script>

<template>
    <div class="toast-container position-fixed bottom-0 end-0 p-3">
        <ToastComp
            v-for="toast in toastStore.toasts"
            :toast="toast"
            :key="toast.id"
            @remove="remove"
        ></ToastComp>
    </div>
</template>
